
import { Component, Vue, Watch } from 'vue-property-decorator'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
@Component({
  components: {
    publicTable
  }
})
export default class SubGameTrend extends Vue {
  loading: boolean = false
  TransTopReqTimer: any
  select = {
    GameType_List: [
    { name: "PVE游戏", value: 1 },
    { name: "PVP游戏", value: 2 },
    { name: "捕鱼游戏", value: 3 },
    { name: "红包游戏", value: 4 },
    { name: "单机游戏", value: 5 },
    { name: "百胜游戏", value: 8 },
    { name: "外接游戏", value: 9 },
    ],
    dataTime: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  }
  colorList = [
    '#145b7d',
    '#72baa7',
    '#78331e',
    '#f05b72',
    '#f58220',
    '#4e72b8',
    '#f26522',
    '#ed1941',
    '#694d9f',
    '#00a6ac',
    '#225a1f',
    '#f2eada',
    '#ef5b9c',
    '#2a5caa',
    '#008792',
    '#1b315e',
    '#f7acbc',
    '#11264f',
    '#ea66a6'
  ]
  tableTotal: any = {
    game_id: -10,
    game_name: '合计',
    sub_user_num: 0,
    bet_user_rate: 1,
    bet_point: 0,
    bet_point_rate: 1,
    back_point: 0,
    percent_point: 0,
    loss_point: 0,
    loss_rate: 0,
    winner_rate: 0,
    winner_user: 0,
    loser_user: 0,
    user_point: 0,
    round_num: 0,
    play_num: 0,
    dataMap: {},
    data: []
  }
  imageData = {
    show: false,
    app_name: '',
    ref: 'subVChartImage',
    checkColumn: 'sub_user_num',
    selectColumn: this.getColumn(false).splice(0, 3),
    options: ['#32CD32', 'rgb(244, 128, 36)'],
    extend: {
      //   xAxis: {
      //     axisLine: {
      //       onZero: false
      //     }
      //   },
      //   yAxis: {
      //     type: "category"
      //   },

      series: {
        smooth: false
        // label: {
        //     show: true,
        //     position: "top",
        //     formatter: v => {
        //         if (v.seriesName.includes("比")) {
        //             return (v.value * 100).toFixed(2) + "%";
        //         } else {
        //             return v.value;
        //         }
        //     }
        // },
        // itemStyle: {
        //     normal: {
        //         color: params => {
        //             return this.colorList[
        //                 params.dataIndex % this.colorList.length
        //             ];
        //         }
        //     }
        // },
        // barMaxWidth: 70
      }
    },
    chartSettings: {
      labelMap: {
        sub_user_num: '投注人数',
        round_num: '游戏人次',
        bet_user_rate: '投注人数占比',
        bet_point: '投注金额',
        bet_point_rate: '投注金额占比',
        user_point: '人均投注金额',
        play_num: '人均游戏次数',
        back_point: '返奖金额',
        percent_point: '税收金额',
        loss_point: '游戏盈亏',
        loss_rate: '盈亏投注比',
        winner_rate: '赢钱人数占比'
      },
      yAxisType: ['percent']
    },
    chartData: {
      columns: ['app_name', 'sub_user_num'],
      rows: []
    }
  }
  //表单数据
  table = {
    params: {
      platform: 0,
      app_id: 0,
      stime: 0,
      etime: 0,
      gtype: 0
    },
    platCheckList: [],
    app_ids: [],
    data: [],
    objData: [],
    dataObj: {},
    columns1: this.getColumn(false),
    columns: this.getColumn(true)
  }
  gameId: number = 0
  getColumn(isExpand) {
    return [
      isExpand
        ? {
            type: 'expand',
            width: 50,
            align: 'center',
            render: (h, params) => {
              return h(publicTable, {
                props: {
                  row: params.row.data,
                  columns: this.table.columns1
                }
              })
            }
          }
        : {
            align: 'center',
            width: 50,
            render: (h, params) => {
              return h('span', '')
            }
          },
      {
        type: 'index',
        title: '序号',
        width: 50,
        align: 'center',
        indexMethod: (el, val) => {
          if (el.game_id == -10) {
            return ''
          } else {
            return el._index + 1
          }
        }
      },
      {
        key: 'game_name',
        align: 'center',
        width: 125,
        resizable: true,
        render: (h, params) => {
          if (params.row.app_names) return h('span', params.row.app_names)
          if (!params.row.app_name) {
            return h('span', params.row.game_name)
          } else {
            return h('span', params.row.app_name)
          }
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '子游戏名称',
            '该子游戏在游戏内显示的游戏名称信息'
          )
      },
      {
        key: 'round_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '游戏人次', '显示该子游戏的游戏人次')
      },
      {
        key: 'sub_user_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注人数',
            '显示该游戏筛选时间内投注人数；'
          )
        }
      },
      {
        key: 'sub_user_num',
        align: 'center',
        sortable: 'custom',
        minWidth: 70,
        render: (h, params) => {
          let str
          if (params.row.game_id < 0) {
            str = '100%'
          } else if (!params.row.data) {
            let item = this.tableTotal.data.find(
              (el: any) => el.date == params.row.date
            )
            str =
              (item.sub_user_num
                ? (params.row.sub_user_num / item.sub_user_num) * 100
                : 0
              ).toFixed(2) + '%'
          } else {
            str =
              (this.tableTotal.sub_user_num
                ? (params.row.sub_user_num / this.tableTotal.sub_user_num) * 100
                : 0
              ).toFixed(2) + '%'
          }
          return h('span', str)
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注人数占比',
            '显示该游戏投注人数的在总投注人数中的占比'
          )
        }
      },
      {
        key: 'bet_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) =>
          h('span', (this as any).getCustomFixed(params.row.bet_point / 10000)),
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注金额',
            '筛选时间范围内该子游戏的投注金额'
          )
        }
      },
      {
        key: 'bet_point',
        align: 'center',
        sortable: 'custom',
        minWidth: 70,
        render: (h, params) => {
          let str = ''
          if (params.row.data) {
            str =
              (this.tableTotal.bet_point
                ? (params.row.bet_point / this.tableTotal.bet_point) * 100
                : 0
              ).toFixed(2) + '%'
          } else {
            let item = this.tableTotal.data.find(
              (el: any) => el.date == params.row.date
            )
            str =
              (item.bet_point
                ? (params.row.bet_point / item.bet_point) * 100
                : 0
              ).toFixed(2) + '%'
          }
          return h('span', str)
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注金额占比',
            '显示该游戏投注金额的在总投注金额中的占比'
          )
        }
      },
      {
        key: 'user_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) =>
          h(
            'span',
            (this as any).getCustomFixed(params.row.user_point / 10000)
          ),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '人均投注金额',
            '显示该游戏投得人均投注金额 = 投注金额/投注人数'
          )
      },
      {
        key: 'play_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '人均游戏次数',
            '筛选时间内，游戏次数/子游戏投注人数'
          )
      },
      {
        key: 'back_point',
        title: '返奖金额',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.back_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '返奖金额',
            '显示该游戏筛选时间内的返奖金额'
          )
        }
      },
      {
        key: 'percent_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.percent_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '税收金额',
            '筛选时间范围内该游戏带来的税收金额'
          )
        }
      },
      {
        key: 'loss_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.loss_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '游戏盈亏',
            '显示该游戏筛选时间内的游戏盈亏金额；投注-返奖'
          )
        }
      },
      {
        key: 'loss_rate',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.loss_rate * 100).toFixed(2) + '%')
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '盈亏投注比',
            '盈亏金额/投注金额'
          )
        }
      },
      {
        key: 'winner_rate',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.winner_rate * 100).toFixed(2) + '%')
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '赢钱人数占比',
            '赢家人数 /（赢家+输家人数)'
          )
        }
      },
      isExpand
        ? {
            title: '趋势图',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              return h(
                'Button',
                {
                  props: {
                    size: 'small',
                    type: 'primary',
                    disabled: !params.row.data
                  },
                  on: {
                    click: () => {
                      this.getImageData(params.row)
                    }
                  }
                },
                '趋势图'
              )
            }
          }
        : { title: '趋势图', align: 'center', minWidth: 70 }
    ]
  }
  closeTimer() {
    this.loading = false
    clearTimeout(this.TransTopReqTimer)
    this.TransTopReqTimer = null
  }
  openTimer() {
    this.closeTimer()
    this.loading = true
    this.TransTopReqTimer = setTimeout(() => {
      this.loading = false
    }, 6000)
  }
  //获取列表
  gitList() {
    if (this.loading) return
    let stime = (this as any).getSecond(this.select.dataTime[0])
    let etime = (this as any).getSecond(this.select.dataTime[1], false)
    if (etime - stime > 15 * 24 * 60 * 60 - 1) {
      this.$Message.error('选择日期时长必须小于等于15天')
      return
    }
    this.table.data = []
    let list: any = []
    let paramAppArray: any = []
    let checkList: any = this.table.platCheckList
    if (checkList.length == 0) {
      if (this.table.app_ids.length == 0) {
        paramAppArray = (this as any).app_list.map((cur: any) => cur.appid) || []
      } else {
        paramAppArray = [...this.table.app_ids]
      }
    } else if (this.table.app_ids.length == 0) {
      ;(this as any).app_list
        .filter((el: any) => checkList.includes(el.platform))
        .reduce((res: any, cur: any) => {
          res.push(cur.appid)
          return res
        }, paramAppArray)
    } else {
      paramAppArray = [...this.table.app_ids]
    }
    let delArray = [...paramAppArray]
    if (paramAppArray) {
      this.openTimer()
      this.tableTotal.round_num = 0
      this.tableTotal.sub_user_num = 0
      this.tableTotal.bet_user_rate = 1
      this.tableTotal.bet_point = 0
      this.tableTotal.bet_point_rate = 1
      this.tableTotal.back_point = 0
      this.tableTotal.percent_point = 0
      this.tableTotal.loss_point = 0
      this.tableTotal.loss_rate = 0
      this.tableTotal.winner_rate = 0
      this.tableTotal.winner_user = 0
      this.tableTotal.loser_user = 0
      this.tableTotal.user_point = 0
      this.tableTotal.data = []
      let httpList: any = []

      for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
        console.log('paramAppArray: ', paramAppArray)
        let item = paramAppArray[k]
        let app: any = (this as any).app_list.find(
          (el: any) => el.appid == item
        )
        let appName = app ? app.name : ''
        this.table.params.stime = stime
        this.table.params.etime = etime
        // const gameItem = this.select.GameType_List.find(
        //   item => item.value === this.gameId
        // )
        
        // const gType = (gameItem && gameItem.value) || 0

        let param = {
          mod: 'root',
          platid: app.platform,
          app_id: item,
          appName: appName,
          param: {
            _mod: 'manager',
            _func: 'GetNewGameDayInfo',
            _param: {
              ...Object.assign({}, this.table.params, {
                platform: app.platform
              }),
              app_id: item
            }
          }
        }
        httpList.push(param)
      }
      let max = Math.min(5, httpList.length)
      for (let i = 0; i < max; i++) {
        this.toHttp(httpList, list)
      }
    }
  }
  toHttp(httpList, list) {
    if (httpList.length > 0) {
      let param = httpList[0]
      httpList.shift()
      let appName = param.appName
      let appId = param.app_id
      TransTopReq(param)
        .then(res => {
          let data = res._param.data || []
          let index = list.findIndex(
            el => el.game_id == this.tableTotal.game_id
          )
          this.tableTotal.winner_user += res._param.win_user
          this.tableTotal.loser_user += res._param.lose_user
          if (index != -1) list.splice(index, 1)
          if (data.length > 0) {
            this.tableTotal.sub_user_num += res._param.bet_user_count
            for (let i = 0, len = data.length; i < len; i++) {
              let el: any = data[i]
              el.play_num = el.sub_user_num
                ? Math.round((el.round_num / el.sub_user_num) * 100) / 100
                : 0
              this.tableTotal.round_num += el.round_num || 0 //游戏人次
              this.tableTotal.bet_point += el.bet_point || 0
              this.tableTotal.back_point += el.back_point || 0
              this.tableTotal.percent_point += el.percent_point || 0
              this.tableTotal.loss_point += el.loss_point || 0
              // this.tableTotal.winner_user += el.winner_user || 0;
              // this.tableTotal.loser_user += el.loser_user || 0;
              this.tableTotal.bet_user_rate = this.tableTotal.sub_user_num
                ? 1
                : 0
              this.tableTotal.bet_point_rate = this.tableTotal.bet_point ? 1 : 0
              this.tableTotal.user_point = this.calcDivField(
                this.tableTotal.bet_point,
                this.tableTotal.sub_user_num
              )
              this.tableTotal.loss_rate = this.calcDivField(
                this.tableTotal.loss_point,
                this.tableTotal.bet_point
              )
              this.tableTotal.winner_rate = this.calcDivField(
                this.tableTotal.winner_user,
                this.tableTotal.winner_user + this.tableTotal.loser_user
              )
              this.tableTotal.play_num = this.tableTotal.sub_user_num
                ? Math.round(
                    (this.tableTotal.round_num / this.tableTotal.sub_user_num) *
                      100
                  ) / 100
                : 0
              this.calcCustom(el)
              let child = (this as any).copyData(el)
              child.app_name = moment(child.etime * 1000)
                .locale('zh-cn')
                .format('YYYYMMDD')
              child.app_names = moment(child.etime * 1000)
                .locale('zh-cn')
                .format('YYYY-MM-DD')
              let tableTotalChild = this.tableTotal.data.find(
                (el: any) => el.app_name == child.app_name
              ) //获取汇总子日期数据
              if (tableTotalChild) {
                this.calcAddField(tableTotalChild, child, false)
                this.calcCustom(tableTotalChild)
                this.updateAllChild(tableTotalChild, res)
                this.tableTotal.data.sort((a, b) => {
                  return a.app_name > b.app_name ? -1 : 1
                })
              } else {
                let newData = { ...child }
                newData.sub_user_num = 0
                this.updateAllChild(newData, res)
                this.tableTotal.data.push(newData)
              }

              let item: any = list.find(
                (element: any) => element.game_id == el.game_id
              )
              if (!item) {
                let newItem = { ...el }
                newItem.data = [child]
                if (res._param.sum_data[newItem.game_id]) {
                  newItem.sub_user_num =
                    res._param.sum_data[newItem.game_id].bet_user || 0
                  newItem.winner_user =
                    res._param.sum_data[newItem.game_id].win_user || 0
                  newItem.loser_user =
                    res._param.sum_data[newItem.game_id].lose_user || 0
                }
                delete res._param.sum_data[newItem.game_id]
                list.push(newItem)
              } else {
                //遍历子元素判断是否存在app_name;
                let timeChild = item.data.find(
                  (element: any) => child.app_name == element.app_name
                )
                if (timeChild) {
                  this.calcAddField(timeChild, child)
                  this.calcCustom(timeChild)
                } else {
                  item.data.push((this as any).copyData(child))
                }
                this.calcAddField(item, el, false, false)
                if (res._param.sum_data[item.game_id]) {
                  item.sub_user_num +=
                    res._param.sum_data[item.game_id].bet_user
                  item.winner_user +=
                    res._param.sum_data[item.game_id].win_user || 0
                  item.loser_user +=
                    res._param.sum_data[item.game_id].lose_user || 0
                }
                delete res._param.sum_data[item.game_id]
                item.data.sort((a, b) => {
                  return a.app_name > b.app_name ? -1 : 1
                })
                this.calcCustom(item)
              }
            }
          }
          this.requestCallBack(httpList, list)
          this.toHttp(httpList, list)
          let obj: any = {}
          obj[appId] = data
          this.table.objData = obj
        })
        .catch(error => {
          this.requestCallBack(httpList, list)
          this.toHttp(httpList, list)
        })
    }
  }

  requestCallBack(list: any, tableData: any) {
    let index = tableData.findIndex(el => el.game_id == this.tableTotal.game_id)
    if (index != -1) tableData.splice(index, 1)
    if (tableData.length > 0) {
      tableData.push((this as any).copyData(this.tableTotal))
      this.table.data = tableData
    }
    if (list.length == 0) {
      this.closeTimer()
    }
  }
  widthResize(val, val1, val2) {
    let { key } = val2
    let find: any = this.table.columns1.find(el => el.key == key)
    if (find) {
      find.width = val
    }
  }
  //设置汇总子数据
  updateAllChild(newData, res) {
    newData.sub_user_num += res._param.day_bet_user[newData.app_name] || 0
    delete res._param.day_bet_user[newData.app_name]
    newData.bet_user_rate = 1
    newData.game_id = -20
  }
  calcCustom(item) {
    item.user_point = item.sub_user_num ? item.bet_point / item.sub_user_num : 0
    item.loss_rate = item.bet_point ? item.loss_point / item.bet_point : 0
    let itemAll = item.winner_user + item.loser_user
    item.winner_rate = itemAll ? item.winner_user / itemAll : 0
    item.play_num = item.sub_user_num
      ? Math.round((item.round_num / item.sub_user_num) * 100) / 100
      : 0
  }
  //除法计算属性   被除数 除数
  calcDivField(val1, val2) {
    return val2 ? val1 / val2 : 0
  }
  //累加属性
  calcAddField(item: any, newItem: any, add = true, winner = true) {
    let filterField = add ? '' : 'sub_user_num'
    let winUser = winner ? '' : 'winner_user'
    let losUser = winner ? '' : 'loser_user'
    for (let key in item) {
      if (
        typeof item[key] == 'number' &&
        !key.includes('_id') &&
        !key.includes('time') &&
        key != 'date' &&
        key != 'play_num' &&
        key != filterField &&
        key != winUser &&
        key != losUser
      )
        item[key] += newItem[key]
    }
  }
  expandId: any
  onExpand(row, status) {
    let obj = this.table.objData
    for (let i in obj) {
      ;(obj[i] as any).map(item => {
        // row.game_id
      })
    }
    this.expandId = row.game_id
    let expand = this.table.data.find((el: any) => el._expanded)
    if (expand) this.$set(expand, '_expanded', false)
    if (status) {
      let newEx = this.table.data.find((el: any) => el.game_id == row.game_id)
      if (newEx) this.$set(newEx, '_expanded', true)
    }
  }
  handleTableClick(row, index) {
    if (this.expandId == row.game_id) {
      if (!this.table.data[index]['_expanded']) {
        this.expandId = null
      }
    } else {
      ;(this.table.data[index]['_userCheck'] as any) = !this.table.data[index][
        '_userCheck'
      ]
    }
  }
  rowClassName(row, index) {
    if (
      this.table.data[index]['_userCheck'] ||
      this.table.data[index]['_expanded']
    ) {
      return 'user-table-check'
    } else {
      return ''
    }
  }
  sortChange(params) {
    // (this.table.data as any).filter((item, index) => {
    //   item["_expanded"] = false;
    //   return item;
    // });
    let find: any = this.table.data.find((el: any) => el._expanded)
    if (find) find._expanded = false
    let order = params.order == 'desc' ? 1 : -1
    let key = params.key
    this.table.data.sort((a: any, b: any) => {
      if (a.game_id == -10) return 1
      if (b.game_id == -10) return -1
      return a[key] * order > b[key] * order ? -1 : 1
    })
  }
  updatePlatCheckList() {
    this.table.app_ids = []
  }
  getImageData(param: any) {
    this.imageData.checkColumn = 'sub_user_num'
    this.imageData.chartData.columns = ['app_name', 'sub_user_num']
    let rows = (this as any).copyData(param.data)
    rows.forEach((el: any) => {
      let item = this.tableTotal.data.find((val: any) => val.date == el.date)
      el.bet_user_rate = item.sub_user_num
        ? el.sub_user_num / item.sub_user_num
        : 0

      el.bet_point_rate = item.bet_point ? el.bet_point / item.bet_point : 0

      for (let i in el) {
        if (i.includes('_point') && !i.includes('_rate')) {
          el[i] = (this as any).getCustomFixed(el[i] / 10000)
        }
      }
    })
    rows.sort((a, b) => {
      return a.stime > b.stime ? 1 : -1
    })
    this.imageData.chartData.rows = rows
    this.imageData.show = true
    this.imageData.app_name = param.game_name
    console.log(this.imageData.chartData)
    this.$nextTick(() => {
      ;(this.$refs[this.imageData.ref] as any).echarts.resize()
    })
  }
  imageIndexChange(val) {
    this.imageData.chartData.columns = [
      this.imageData.chartData.columns[0],
      val
    ]
    ;(this.$refs[this.imageData.ref] as any).echarts.resize()
  }
  getChartSetting() {
    if (this.imageData.checkColumn.includes('_rate')) {
      return this.imageData.chartSettings
    } else {
      return Object.assign({}, this.imageData.chartSettings, {
        yAxisType: ['normal']
      })
    }
  }
  getSearchData(isStart: Boolean = true) {
    return `(${moment(this.table.params.stime * 1000)
      .locale('zh-cn')
      .format('YYYY/MM/DD')} - ${moment(this.table.params.etime * 1000)
      .locale('zh-cn')
      .format('YYYY/MM/DD')})`
  }
  created() {
    this.gitList()
  }
}
